import { ChildType } from "@common/types/tree-types";
import getParentId from "./get-parent-id";

export const buildNodeSelectionNodeData = (
  child: ChildType,
  list: ChildType,
) => {
  const buildLastActualValueTimestamp = (child: any) => {
    return child?.attributes !== undefined
      ? child?.attributes?.last_known_value_timestamp
      : null;
  };

  const buildLastActualValue = (child: any) => {
    return child?.attributes !== undefined
      ? child?.attributes?.last_known_value
      : null;
  };

  const buildNodeClass = (child: any) => {
    return child?.attributes !== undefined
      ? child?.attributes?.node_class
      : null;
  };

  const buildSmallestSampleIntervall = (child: any) => {
    return child?.attributes !== undefined
      ? child?.attributes?.sample_interval_in_seconds
      : null;
  };

  const buildDataAcquisitionType = (child: any) => {
    return child?.attributes !== undefined
      ? child?.attributes?.data_acquisition_type
      : null;
  };

  const buildDataType = (child: any) => {
    return child?.attributes !== undefined
      ? child?.attributes?.data_type?.type_node_id
      : null;
  };

  const buildDataTypeAsString = (child: any) => {
    return child?.attributes !== undefined
      ? child?.attributes?.data_type_as_string
      : null;
  };

  const buildUnit = (child: any) => {
    return child?.attributes !== undefined &&
      child?.attributes?.unit !== undefined &&
      child?.attributes?.unit !== null &&
      child?.attributes?.unit?.code !== 0 &&
      child?.attributes?.unit?.code !== null &&
      child?.attributes?.unit?.display_name !== undefined
      ? child?.attributes?.unit
      : null;
  };

  const newNodeSelectionNodeData = {
    name: child.name,
    lastActualValueTimestamp: buildLastActualValueTimestamp(child),
    lastActualValue: buildLastActualValue(child),
    nodeClass: buildNodeClass(child),
    smallestSampleIntervall: buildSmallestSampleIntervall(child),
    nodeId: child.id,
    parentNodeId: getParentId(list, child.key, child.id),
    key: child.key,
    dataAcquisitionType: buildDataAcquisitionType(child),
    dataType: buildDataType(child),
    dataTypeAsString: buildDataTypeAsString(child),
    unit: buildUnit(child),
  };

  return newNodeSelectionNodeData;
};
